// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_6d05e491"};